import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '@app/core/loading/loading.service';
import { SKIP_GLOBAL_LOADING } from './http-context.tokens';

/** Prende el overlay global mientras la request está en vuelo. `finalize` lo apaga también ante error o cancelación. */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_LOADING)) {
    return next(req);
  }

  const loading = inject(LoadingService);
  loading.start();
  return next(req).pipe(finalize(() => loading.stop()));
};
